import { PayloadAction } from '@reduxjs/toolkit';
import { OrderItem } from 'gql/graphql';
import { CartState } from 'store/cart/types';

const setCartItemReducer = (state: CartState, action: PayloadAction<OrderItem>) => {
  if (!state.cart || !state.cart.carts || !state.cart.carts[0]) return;
  if (!state.cart.carts[0].items) {
    state.cart.carts[0].items = [];
  }
  const itemIndex = state.cart.carts[0].items?.findIndex((item) => item?.orderItemId === action.payload.orderItemId);
  if (itemIndex !== undefined && itemIndex > -1) {
    state.cart.carts[0].items[itemIndex] = action.payload;
  } else {
    state.cart.carts[0].items.push(action.payload);
  }
};

export default setCartItemReducer;
